import HttpService from "./HttpService";

const BASE = () => window.API_URL + "/communication/notification-templates";

const NotificationTemplateService = {
  list: (employerId) =>
    HttpService.getAxiosClient().get(
      BASE() +
        (employerId ? `?employerId=${encodeURIComponent(employerId)}` : "")
    ),

  getByProcess: (idProcess) =>
    HttpService.getAxiosClient().get(
      `${BASE()}?idProcess=${encodeURIComponent(idProcess)}`
    ),

  getById: (id) => HttpService.getAxiosClient().get(`${BASE()}/${id}`),

  create: (body) => HttpService.getAxiosClient().post(BASE(), body),

  update: (id, body) =>
    HttpService.getAxiosClient().put(`${BASE()}/${id}`, body),

  getNotificationTypes: () =>
    HttpService.getAxiosClient().get(`${BASE()}/notification-types`),
};

export default NotificationTemplateService;
